import { render, staticRenderFns } from "./signalR.vue?vue&type=template&id=a1a14230&"
import script from "./signalR.vue?vue&type=script&lang=js&"
export * from "./signalR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports